module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/trekking.8940224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/trekking.jpg
// module id = GiLh
// module chunks = 0